module.exports = __webpack_public_path__ + "media/music_2.ebd12bda.mp3";